import React, { useState, useEffect } from "react"
import { useMemo } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ToastContainer, toast } from "react-toastify"
import { getINSCOMPANYReset, getINSCOMPANYStart, UpdateINSCOMPANYReset } from "store/SuperAdmin/Lob-SubLob-company-income/InsuranceAction"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Button,
  Spinner,
  Badge,
} from "reactstrap"
import DeleteModal from "components/Common/DeleteModal"
import { Link, useParams, useLocation } from "react-router-dom"
import TableContainer from "components/Common/TableContainer"
import { useDispatch, useSelector } from "react-redux"

// CREATE LOB :
import CreateINSCompany from "./CreateType"
import UpdateINSCompany from "./UpdateType"

const Home = () => {
  const [dmodal, setdModal] = useState(false)

  const [updateData, setUpdateData] = useState()

  const [OpenModal, setOpenModal] = useState(false)
  const [UpdateModal, setUpdatModal] = useState(false)

  const CreateFunc = () => {
    setOpenModal(!OpenModal)
  }

  const OpenUpdateModel = () => {
    setUpdatModal(!UpdateModal)
  }
  const { loading, INSCOMPANY, updated, Iscreated, deleted } = useSelector(
    state => state.SuperAdminLob
  )
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getINSCOMPANYStart())
  }, [])

  useEffect(() => {
    if (Iscreated) {
      toast.success("Company name added successfully")
      CreateFunc()
      dispatch(getINSCOMPANYReset());
      dispatch(getINSCOMPANYStart());
    }
  }, [Iscreated])

  useEffect(()=>{
    if(updated){
      toast.success("Company name updated successfully")
      OpenUpdateModel()
      dispatch(UpdateINSCOMPANYReset());
      dispatch(getINSCOMPANYStart());
    }
  },[updated]);

  const handleDelete = id => {}

  const handleUpdate = id => {
    const filterData = INSCOMPANY.data.filter(item => item.id === id)
    setUpdateData(filterData)
    setUpdatModal(true)
  }

  const columns = useMemo(() => [
    {
      Header: "Sr No",
      Cell: cellProps => {
        return <>{cellProps.row.original.id}</>
      },
    },
    {
      Header: "Insurnace Type",
      accessor: "type",
      Cell: cellProps => {
        return <>{cellProps.row.original.type}</>
      },
    },
    {
      Header: "Company Name",
      accessor: "name",
      Cell: cellProps => {
        return <>{cellProps.row.original.name}</>
      },
    },
    {
        Header: "Color Code",
        accessor: "color_code",
        Cell: cellProps => {
          return <>{cellProps.row.original.color_code}</>
        },
      },
      {
        Header: "Color",
        Cell: cellProps => {
          return (
            <>
              {" "}
              <button
                style={{
                  backgroundColor: `${cellProps.row.original.color_code}`,
                  width: "40px",
                  height: "30px",
                  border: "none",
                }}
              ></button>
            </>
          )
        },
      },

    {
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      Cell: cellProps => {
        const currentDate = new Date()
        const endDate = new Date(cellProps.row.original.end_date)
        return (
          <>
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li
                onClick={() => {
                  handleUpdate(cellProps.row.original.id)
                }}
                className="btn btn-sm btn-soft-info"
                id={`edittooltip-${cellProps.row.original.id}`}
              >
                <i className="mdi mdi-pencil-outline" />
                <UncontrolledTooltip
                  placement="top"
                  target={`edittooltip-${cellProps.row.original.id}`}
                >
                  Edit
                </UncontrolledTooltip>
              </li>

              {/* <li>
                <Link
                  to={`/update-policy/${id}/${cellProps.row.original.id}`}
                  onClick={() => {
                    handleDelete(cellProps.row.original.id)
                  }}
                  className="btn btn-sm btn-soft-info"
                  id={`deletetooltip-${cellProps.row.original.id}`}
                >
                  <i className="mdi mdi-delete" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`deletetooltip-${cellProps.row.original.id}`}
                  >
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </li> */}
            </ul>
          </>
        )
      },
    },
  ])

  return (
    <React.Fragment>
      <DeleteModal show={dmodal} />
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <h3 className="mb-0 card-title flex-grow-1">Insurance</h3>

                    <Button onClick={CreateFunc} className="btn btn-dark">
                      {" "}
                      Add Insurance company
                    </Button>
                  </div>
                </CardBody>

                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={INSCOMPANY?.data || []}
                    isGlobalFilter={true}
                    isAddOptions={false}
                    loading={loading}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    isShowingPageLength={true}
                    customPageSize={10}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={OpenModal} toggle={CreateFunc} size="md">
            <ModalHeader toggle={CreateFunc} tag="h4">
              <h3>Add Company Name</h3>
            </ModalHeader>
            <ModalBody>
            <CreateINSCompany/>            </ModalBody>
          </Modal>

          {/* UPDATE MODAL */}
          <Modal isOpen={UpdateModal} toggle={OpenUpdateModel} size="md">
            <ModalHeader toggle={OpenUpdateModel} tag="h4">
              <h3>Update Company Name</h3>
            </ModalHeader>
            <ModalBody>
              <UpdateINSCompany updateData={updateData} />
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

export default Home
